import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

const TextFilter = ({ inputValue, handleInputChange, handleInputKeyPress, handleSearchClick }) => {
    return (
        <div className="filter-item">
            <label htmlFor="text-filter">Text Filter:</label>
            <div>
                <input
                    className="filter-input"
                    type="text"
                    id="text-filter"
                    placeholder="Search..."
                    value={inputValue}
                    onChange={handleInputChange}
                    onKeyPress={handleInputKeyPress}
                    autoComplete="off"
                    autoCorrect="off"
                    spellCheck="false"
                />
                <FontAwesomeIcon
                    className="filter-icon"
                    icon={faMagnifyingGlass}
                    onClick={handleSearchClick}
                />
            </div>
        </div>
    );
};

TextFilter.propTypes = {
    inputValue: PropTypes.string.isRequired,
    handleInputChange: PropTypes.func.isRequired,
    handleInputKeyPress: PropTypes.func.isRequired,
    handleSearchClick: PropTypes.func.isRequired,
};

export default TextFilter;
